module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Personal info","success-save":"Personal info was saved successfully","user-password-label":"Your new password:","notify-me":"Send me email notifications"},"ru":{"title":"Профиль пользователя","success-save":"Профиль пользователя успешно сохранен","user-password-label":"Новый пароль:","notify-me":"Посылать мне уведомления"}}')
  delete Component.options._Ctor
}
